export default __webpack_public_path__ + "static/media/arrow-down-left.0ed0c5ee.svg";